import React from 'react';
import FileIcon from '../FileIcon';
import { ArrowDownCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

function FilesList({ children }) {
  return <div className="grid grid-cols-1 gap-x-4 overflow-y-auto w-full rounded">{children}</div>;
}

function FilesListItem({ file, onDownloadFile, isPreview }) {
  const isDisabled = isPreview;

  return (
    <button
      type="button"
      onClick={onDownloadFile}
      disabled={isDisabled}
      className={clsx(
        'flex flex-row gap-4 px-2 py-0.5 items-center justify-start border-b border-[var(--cp_checkout-divider-border-color)] w-full text-left text-[var(--cp_checkout-confirmation-text-color)] [font-size:var(--cp_checkout-confirmation-text-font-size)] [line-height:var(--cp_checkout-confirmation-text-line-height)] [font-family:var(--cp_checkout-confirmation-text-font-family)] [font-weight:var(--cp_checkout-confirmation-text-font-weight)] [font-style:var(--cp_checkout-confirmation-text-font-style)]',
        {
          'hover:bg-gray-50 cursor-pointer': !isDisabled,
          'cursor-default': isDisabled,
        },
      )}
    >
      <div className="p-1">
        <FileIcon type={file.type} />
      </div>

      <div className="font-medium truncate">{file.name}</div>

      <div className="ml-auto">
        <div className="text-[var(--cp_checkout-confirmation-text-color,var(--cp_text-primary))] px-1.5 py-1.5">
          <ArrowDownCircleIcon className="h-7 w-7" />
        </div>
      </div>
    </button>
  );
}

FilesList.List = FilesList;
FilesList.Item = FilesListItem;

export default FilesList;
